// frontend/src/hooks/useInFlight.js
//
// Which rows of a list have a request in flight, and which action each one
// runs — so a click on one row spins that row's button and leaves every
// other row's buttons as they are. Writes on two rows may overlap: each row
// keeps its entry until its own request settles.
//
//   const { running, track } = useInFlight();
//   await track(rowId, 'merge', () => mutateAsync(...))  // resolves/rejects as the request does
//   running[rowId]                                        // 'merge' while in flight, else undefined

import { useCallback, useState } from 'react';

export function useInFlight() {
  const [running, setRunning] = useState({});

  const track = useCallback(async (key, action, request) => {
    setRunning((current) => ({ ...current, [key]: action }));
    try {
      return await request();
    } finally {
      setRunning((current) => {
        const next = { ...current };
        delete next[key];
        return next;
      });
    }
  }, []);

  return { running, track };
}
